import React, { Fragment } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import AuthPage from 'routes/Components/AuthPage'

const AuthRouter = ({ isAuthenticated, permissions }) => {
  return (
    <Fragment>
      <Routes>
        <Route path="/" element={<Navigate to="signin" replace />} />
      </Routes>
      <AuthPage isAuthenticated={isAuthenticated} permissions={permissions} />
    </Fragment>
  )
}

export default AuthRouter
